import { Box } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import { Grid, InterfaceNameValue } from '@tiendanube/components';
import { InterfaceNameBooleanValue } from 'commons/types';
import { PersonalDataState } from 'domains/PagoNubeOnboarding/Onboarding/types';
import { InputConfig } from 'domains/PagoNubeOnboarding/Onboarding/utils';
import useTranslationPagoNubeOnboarding from 'domains/PagoNubeOnboarding/useTranslationPagoNubeOnboarding';

interface PhoneNumberDataProps {
  element: InputConfig;
  errors: Partial<Record<string, string>>;
  handleOnBlur: (data: InterfaceNameValue) => void;
  onChange: (data: InterfaceNameValue | InterfaceNameBooleanValue) => void;
  personalDataState: PersonalDataState;
}

const phoneNumberPrefixKey = 'phoneNumberPrefix';

function PhoneNumberData({
  element,
  errors,
  handleOnBlur,
  onChange,
  personalDataState,
}: Readonly<PhoneNumberDataProps>) {
  const t = useTranslationPagoNubeOnboarding('personalData.phoneNumberData');

  const key = element.key;

  return (
    <Box marginBottom="4">
      <Grid fluid>
        <Grid.Row>
          <Grid.Column sm={8} md={8} lg={8}>
            <FormField.Input
              key={phoneNumberPrefixKey}
              appearance={errors[phoneNumberPrefixKey] ? 'danger' : 'none'}
              label={t('prefix')}
              type="text"
              onBlur={(e) =>
                handleOnBlur({
                  name: phoneNumberPrefixKey,
                  value: e.target.value,
                })
              }
              onChange={(event) =>
                onChange({
                  name: phoneNumberPrefixKey,
                  value: event.target.value,
                })
              }
              property={phoneNumberPrefixKey}
              value={
                personalDataState[phoneNumberPrefixKey] || t('prefixValue')
              }
              helpText={errors[phoneNumberPrefixKey]}
              showHelpText={!!errors[phoneNumberPrefixKey]}
            />
          </Grid.Column>
          <Grid.Column sm={4} md={4} lg={4}>
            <FormField.Input
              key={key}
              appearance={errors[key] ? 'danger' : 'none'}
              label={t(key)}
              type={element.type}
              onBlur={(e) => handleOnBlur({ name: key, value: e.target.value })}
              onChange={(event) =>
                onChange({ name: key, value: event.target.value })
              }
              property={key}
              value={personalDataState[key] || ''}
              placeholder={t('phoneNumberPlaceholder')}
              helpText={errors[key]}
              showHelpText={!!errors[key]}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Box>
  );
}

export default PhoneNumberData;
